import { render } from "./PatientScreeningReport.vue?vue&type=template&id=382109b0&scoped=true"
import script from "./PatientScreeningReport.js?vue&type=script&lang=js"
export * from "./PatientScreeningReport.js?vue&type=script&lang=js"

import "./PatientScreeningReport.vue?vue&type=style&index=0&id=382109b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382109b0"]])

export default __exports__